export default __webpack_public_path__ + "assets/models/f603347ff052e7d9b7214b99cda7e748.glb";